import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { finalize } from 'rxjs';
import { ApiErrorResponse } from '../../../core/classes/ApiErrorResponse';
import { BaseModalComponent } from '../../../core/layout/components/abstracts/base-modal.component';
import { WorkerService } from '../../../features/worker/core/services/WorkerService';
import { SafePipe } from '../../pipes/safe.pipe';
import { TranslatePipe } from '../../pipes/trans.pipe';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-pdf-viewer-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    SafePipe
  ],
  templateUrl: './pdf-viewer-modal.component.html',
  styleUrl: './pdf-viewer-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfViewerModalComponent extends BaseModalComponent<{ base64Content?: string; }> {

  public readonly isPrinting = signal(false);

  public readonly printDirectly = computed(() => {
    return this.terminalsStore.selectedTerminal() && 
      this.terminalParametersMap()[this.terminalParameterKeys.WEB_CASH_DOCUMENTS_PRINT_DIRECTLY];
  });

  public readonly modalMinWidth = computed(() => {
    return this.printDirectly() ? 'auto' : '90%';
  });

  public get pdfSrc(): string | null {
    if (this.data?.base64Content) {
      const baseUrl = 'data:application/pdf;base64,' + this.data.base64Content;
      return !this.printDirectly() ? baseUrl + `#zoom=150` : baseUrl;
    }
    
    return null;
  }

  private readonly _workerService = inject(WorkerService);

  public override open(val?: { base64Content?: string; }): void {
    this.isPrinting.set(false);
    super.open(val);
  }

  public printPdf(): void {
    if (!this.data?.base64Content) {
      return;
    }

    this.isPrinting.set(true);

    this._workerService.printDocument(this.data.base64Content)
      .pipe(
        finalize(() => this.isPrinting.set(false))
      )
      .subscribe({
        next: () => this.close(),
        error: ({ error }: ApiErrorResponse) => {
          this.notificationService.pushError(
            'Fehler'.trans('notifications/error.Title'),
            error.message.trans(`print-document/notifications/${error.message}.Message`)
          );
        }
      });
  }
}
